import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-[#0B1121] py-24">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#5CBDB0] hover:underline mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Link>

        <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-8">
          Termini e Condizioni
        </h1>

        <div className="prose prose-invert prose-lg max-w-none">
          <div className="text-white/70 space-y-6">
            <p className="text-white/50 text-sm">
              Ultimo aggiornamento: 16 Febbraio 2026
            </p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                1. Premessa
              </h2>
              <p>
                I presenti Termini e Condizioni regolano l'utilizzo del sito web DODIPA (di seguito "Sito") 
                e i servizi offerti da F&P IDEA S.R.L.S.
              </p>
              <p className="mt-4">
                L'accesso e l'utilizzo del Sito comportano l'accettazione integrale dei presenti Termini. 
                Se non si accettano tali condizioni, si prega di non utilizzare il Sito.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                2. Identificazione del Titolare
              </h2>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Ragione Sociale:</strong> F&P IDEA S.R.L.S.</li>
                <li><strong className="text-white">Marchio:</strong> DODIPA (in concessione esclusiva a F&P IDEA S.R.L.S.)</li>
                <li><strong className="text-white">Sede Legale:</strong> Corso Pietro Giannone 1/A, 71121 Foggia (FG)</li>
                <li><strong className="text-white">P.IVA / C.F.:</strong> 04328400710</li>
                <li><strong className="text-white">REA:</strong> FG-318897</li>
                <li><strong className="text-white">Capitale Sociale:</strong> € 1.000,00 interamente versato</li>
                <li><strong className="text-white">Email:</strong> info@dodipa.it</li>
                <li><strong className="text-white">PEC:</strong> fpidea@pec.it</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                3. Servizi Offerti
              </h2>
              <p>
                DODIPA offre servizi di consulenza nel settore energetico e della finanza agevolata, tra cui:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li>Consulenza energetica per ottimizzazione consumi e tariffe</li>
                <li>Verifica agevolazioni fiscali per POD e PDR aziendali</li>
                <li>Recupero importi pagati erroneamente sulle bollette</li>
                <li>Assistenza per accesso a bandi e finanziamenti agevolati</li>
                <li>Installazione impianti fotovoltaici</li>
                <li>Pratiche autorizzative e rapporti con GSE</li>
                <li>Creazione contatori BT e MT</li>
              </ul>
              <p className="mt-4">
                I servizi specifici e le relative condizioni economiche saranno oggetto di accordi separati 
                tra le parti.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                4. Utilizzo del Sito
              </h2>
              <p>
                L'utente si impegna a utilizzare il Sito in modo lecito e conforme alla normativa vigente. 
                È vietato:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li>Utilizzare il Sito per scopi illeciti o fraudolenti</li>
                <li>Trasmettere contenuti offensivi, diffamatori o illegali</li>
                <li>Tentare di accedere a sistemi o dati non autorizzati</li>
                <li>Compromettere la sicurezza o il funzionamento del Sito</li>
                <li>Raccogliere dati di altri utenti senza autorizzazione</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                5. Proprietà Intellettuale
              </h2>
              <p>
                Tutti i contenuti presenti sul Sito (testi, immagini, loghi, grafica, software) sono di 
                proprietà di F&P IDEA S.R.L.S. o dei rispettivi titolari e sono protetti dalle leggi 
                sul diritto d'autore e sulla proprietà intellettuale.
              </p>
              <p className="mt-4">
                È vietata la riproduzione, distribuzione, modifica o utilizzo dei contenuti senza 
                autorizzazione scritta del Titolare.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                6. Limitazione di Responsabilità
              </h2>
              <p>
                Il Titolare non garantisce che il Sito sia sempre disponibile, privo di errori o sicuro. 
                Il Titolare non è responsabile per:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li>Interruzioni temporanee del servizio</li>
                <li>Errori o inesattezze nei contenuti</li>
                <li>Danni derivanti dall'uso del Sito</li>
                <li>Contenuti di siti terzi collegati</li>
              </ul>
              <p className="mt-4">
                Le informazioni presenti sul Sito hanno carattere puramente informativo e non costituiscono 
                offerta al pubblico né consulenza professionale vincolante.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                7. Privacy e Cookie
              </h2>
              <p>
                Il trattamento dei dati personali è disciplinato dalla nostra{' '}
                <Link to="/privacy-policy" className="text-[#5CBDB0] hover:underline">
                  Informativa Privacy
                </Link>{' '}
                e dalla{' '}
                <Link to="/cookie-policy" className="text-[#5CBDB0] hover:underline">
                  Cookie Policy
                </Link>.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                8. Comunicazioni
              </h2>
              <p>
                Per qualsiasi comunicazione relativa ai presenti Termini, l'utente può contattare il Titolare ai seguenti recapiti:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Email:</strong> info@dodipa.it</li>
                <li><strong className="text-white">PEC:</strong> fpidea@pec.it</li>
                <li><strong className="text-white">WhatsApp:</strong> +39 345 350 9743</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                9. Legge Applicabile e Foro Competente
              </h2>
              <p>
                I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia derivante 
                dall'interpretazione o esecuzione dei presenti Termini, sarà competente in via esclusiva 
                il Foro di Foggia.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                10. Modifiche ai Termini
              </h2>
              <p>
                Il Titolare si riserva il diritto di modificare i presenti Termini in qualsiasi momento. 
                Le modifiche saranno efficaci dalla data di pubblicazione sul Sito. L'uso continuato del 
                Sito dopo le modifiche costituisce accettazione delle stesse.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                11. Disposizioni Finali
              </h2>
              <p>
                Qualora una delle clausole dei presenti Termini fosse ritenuta nulla o invalida, tale 
                circostanza non pregiudicherà la validità delle restanti clausole.
              </p>
              <p className="mt-4">
                I presenti Termini costituiscono l'accordo integrale tra l'utente e il Titolare relativamente 
                all'uso del Sito.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
